import { render, staticRenderFns } from "./TagForm.vue?vue&type=template&id=e772f0e8&scoped=true&"
import script from "./TagForm.vue?vue&type=script&lang=js&"
export * from "./TagForm.vue?vue&type=script&lang=js&"
import style0 from "./TagForm.vue?vue&type=style&index=0&id=e772f0e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e772f0e8",
  null
  
)

export default component.exports